import { usePageEditorStore } from 'app/store/editor';

export const useSyncLayoutData = () => {
    const markDirty = usePageEditorStore((state) => state.markDirty);

    const flush = usePageEditorStore((state) => state.save);

    return {
        flush,
        markDirty,
    };
};
